import React from 'react';

/**
 * StatCard component for displaying statistics in the dashboard
 * @param {string} title - The title of the stat
 * @param {string|number} value - The value to display
 * @param {string} description - Short description text
 * @param {React.ReactNode} icon - Icon element to display
 */
function StatCard({ title, value, description, icon }) {
  return (
    <div className="overflow-hidden bg-gray-800 rounded-lg shadow border border-gray-700">
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            {icon}
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-300 truncate">{title}</dt>
              <dd>
                <div className="text-lg font-medium text-white">{value}</div>
              </dd>
              <dd className="mt-1 text-sm text-gray-400">{description}</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatCard; 